const mainColumns = [
    {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        render: (text, record) => (
            <div>
                <div className="font-semibold">{text}</div>
                <div className="text-sm text-gray-500">{record.email}</div>
            </div>
        ),
    },
    {
        title: 'User ID',
        dataIndex: 'userId',
        key: 'userId',
        render: (text) => (
            <div className="font-mono text-xs bg-gray-100 px-2 py-1 rounded max-w-xs truncate" title={text}>
                {text}
            </div>
        ),
    },
    {
        title: 'IB Type',
        dataIndex: 'ibType',
        key: 'ibType',
        render: (text) => (
            <p color={text === 'Self' ? 'blue' : 'green'}>
                {text}
            </p>
        ),
    },
    {
        title: 'Level',
        dataIndex: 'level',
        key: 'level',
        render: (text) => (
            <p color="purple">Level {text}</p>
        ),
    },
    {
        title: 'Referral Code',
        dataIndex: 'referralCode',
        key: 'referralCode',
        render: (text) => (
            <div className="font-mono text-sm bg-blue-50 px-2 py-1 rounded">
                {text}
            </div>
        ),
    },
    {
        title: 'Affiliate Code',
        dataIndex: 'affiliateCode',
        key: 'affiliateCode',
        render: (text) => (
            <div className="font-mono text-sm bg-green-50 px-2 py-1 rounded">
                {text}
            </div>
        ),
    },
    {
        title: 'Commission Mode',
        dataIndex: 'ibCommissionMode',
        key: 'ibCommissionMode',
        render: (text) => (
            <p color="orange">Mode {text}</p>
        ),
    },
    {
        title: 'Total Plans',
        dataIndex: 'accountsList',
        key: 'totalPlans',
        render: (accountsList) => (
            <p color="cyan">{accountsList?.length || 0} Plans</p>
        ),
    },
];

const buildColumns = (maxLevelOrLevels = 0) => {
    const inferredMaxLevel = Array.isArray(maxLevelOrLevels)
        ? maxLevelOrLevels.reduce((max, levelEntry) => {
            const levelNumber = Number(levelEntry?.level ?? levelEntry) || 0;
            return levelNumber > max ? levelNumber : max;
        }, 0)
        : Number(maxLevelOrLevels) || 0;

    const levelColumns = Array.from({ length: inferredMaxLevel }, (_, index) => {
        const levelNumber = index + 1;
        return {
            title: `Level ${levelNumber}`,
            key: `level_${levelNumber}`,
            render: (_, record) => {
                const match = record?.levels?.find((lvl) => Number(lvl?.level) === levelNumber);
                return match?.commission ?? '-';
            },
        };
    });

    return [
        {
            title: 'Plan Name',
            dataIndex: 'planName',
            key: 'planName',
            render: (text) => (
                <div className="font-semibold text-blue-600">{text}</div>
            ),
        },
        {
            title: 'Group Name',
            dataIndex: 'groupName',
            key: 'groupName',
            render: (text) => (
                <div className="text-sm text-gray-600 max-w-xs truncate" title={text}>
                    {text}
                </div>
            ),
        },
        {
            title: 'Group ID',
            dataIndex: 'groupId',
            key: 'groupId',
            render: (text) => (
                <div className="font-mono text-xs bg-gray-100 px-2 py-1 rounded max-w-xs truncate" title={text}>
                    {text}
                </div>
            ),
        },
        ...levelColumns,
    ];
};

export { mainColumns, buildColumns };
